module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid24_980x814.075bc26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid24_980x814.jpg
// module id = 2nsz
// module chunks = 0